import { registerPlugin } from '@capacitor/core';

import type { GenericsPlugin } from './definitions';

const Generics = registerPlugin<GenericsPlugin>('Generics', {
  web: () => import('./web').then(m => new m.GenericsWeb()),
});

export * from './definitions';
export { Generics };
